'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PAFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-15bb0l4ft", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-1yxche9vt", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-1rzzn0fpa" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-1rzzn0fpa", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-15bb0l4ft)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-1rzzn0fpa" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e31d1c",
        d: "M16 0h16v12H16zm7.02 19.15l-2.302 1.424.894-2.391-1.957-1.811h2.374l.992-2.587.757 2.587h2.377l-1.713 1.81.839 2.392z",
        mask: "url(#mantine-1yxche9vt)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#2e42a5",
        d: "M9.02 8.365L6.719 9.79l.894-2.392-1.957-1.81H8.03L9.021 3l.757 2.587h2.377l-1.713 1.81.839 2.393zM0 12h16v12H0z",
        mask: "url(#mantine-1yxche9vt)"
      }
    )))
  );
}

export { PAFlag };
//# sourceMappingURL=PA.mjs.map
